/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ serviceId: ZodTypes.Id });

export const ProxyService = {
  id: 'proxy-service.get',
  tag: 'Inventory',
  summary: 'Proxy service',
  description: 'Proxy service',
  method: 'get',
  route: (params: z.infer<typeof Params>) => `/proxy/service/${params.serviceId}`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
